<!-- Header  -->

<header class="header"
    [style.background]="'linear-gradient(to right, ' + companyData?.brandColor">

    <img [src]="companyData?.companyLogo" alt="Company Logo" class="company-logo">
</header>

<!-- Progress Bar  -->
<div class="col-12 pb-4 px-3 main-content">
    <!-- Stops Dropdown and Filtering Buttons  -->
    <div class="search-wrapper">
        <!-- Select Timezone  -->
        <div class="d-none d-lg-block">
            <p-dropdown [options]="timezones" optionLabel="name" placeholder="Select Timezone" [showClear]="true"
                [(ngModel)]="selectedTimezone" (onChange)="onTimezoneChange($event.value?.display)">
                <ng-template let-tz pTemplate="item">
                    <div class="timezone-dropdown">
                        <div>{{ tz.name }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="search-section">
            <div class="d-flex search-input" style="width: 300px;">
                <input placeholder='Insert ID (s)' type="text" class="form-control" [(ngModel)]="refrenceNumber"
                    (ngModelChange)="onReferenceNumberChange()">
            </div>

            <!-- Buttons  -->
            <div class="track-buttons">
                <div>
                    <button class="btn btn-success d-flex gap-1 align-items-center h-full" [disabled]="!refrenceNumber"
                        (click)="trackShipment()">
                        <span>Track</span>
                    </button>
                </div>
                <div>
                    <button class="btn btn-success d-flex gap-1 align-items-center h-full" (click)="navigateToLogin()"
                        [routerLink]="['/tracked-shipments/shipment-profile',refrenceNumber]">
                        <span>Login</span>
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="progress-bar-wrapper">
        <progress-bar [refNumber]="currentRef"></progress-bar>
        <!-- Scroll Buttons -->
        <button class="scroll-button left-button" *ngIf="currentRefIndex >0" (click)="prevRef()">
            <mat-icon fontIcon="chevron_left" aria-hidden="false" aria-label="Scroll left"></mat-icon>
        </button>

        <button class="scroll-button right-button" *ngIf="currentRefIndex <this.refNumbers.length - 1"
            (click)="nextRef()">
            <mat-icon fontIcon="chevron_right" aria-hidden="false" aria-label="Scroll right"></mat-icon>
        </button>
    </div>


</div>
<!-- Footer  -->
<footer class="footer m-0">
    <div>
        <p class="copyright-left">
            Copyright &copy; {{ currentDate | date: 'yyyy' }}
            <a href="https://www.e4score.com/" target="_blank">
                IGIT ENTERPRISES, INC. D/B/A E4SCORE.COM
            </a>
            <span>, ALL RIGHTS RESERVED.</span>
        </p>
        <p>
            Powered by
            <a href="https://www.e4score.com/eztrack-trailer-and-asset-tracking/" target="_blank">
                e4score
            </a>
        </p>
    </div>
</footer>